namespace TabAurous.Inventory {
    export interface StockAllocatedItemsForm {
    }

    export class StockAllocatedItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.StockAllocatedItems';
    }
}
